import React, { useEffect, useState } from 'react';
import { FaSave, FaTimes, FaSearch } from 'react-icons/fa';
import { classAPI, courseAPI } from '../../../../utils/api';
import Swal from 'sweetalert2';

function MultiSelect({ options, value, onChange, placeholder }) {
  const [search, setSearch] = useState('');
  const filtered = options.filter(o => o.label.toLowerCase().includes(search.toLowerCase()));
  const toggle = (id) => {
    if (value.includes(id)) onChange(value.filter(v => v !== id));
    else onChange([...value, id]);
  };
  return (
    <div style={{ border: '1.5px solid #e2e8f0', borderRadius: 10, background: '#f8fafc', overflow: 'hidden' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '8px 12px', borderBottom: '1px solid #e2e8f0' }}>
        <FaSearch style={{ color: '#94a3b8', fontSize: '0.75rem', flexShrink: 0 }} />
        <input
          value={search}
          onChange={e => setSearch(e.target.value)}
          placeholder={`Search ${placeholder}…`}
          style={{ border: 'none', background: 'transparent', outline: 'none', width: '100%', fontSize: '0.87rem', color: '#374151' }}
        />
      </div>
      <div style={{ maxHeight: 180, overflowY: 'auto', padding: '4px 0' }}>
        {filtered.map(o => (
          <label key={o.value} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '7px 14px', cursor: 'pointer', fontSize: '0.88rem', color: '#374151', transition: 'background 0.12s' }}
            onMouseEnter={e => e.currentTarget.style.background = '#f1f5f9'}
            onMouseLeave={e => e.currentTarget.style.background = ''}>
            <input type="checkbox" checked={value.includes(o.value)} onChange={() => toggle(o.value)}
              style={{ accentColor: 'var(--eduss-primary)', width: 15, height: 15, cursor: 'pointer' }} />
            {o.label}
          </label>
        ))}
        {filtered.length === 0 && (
          <div style={{ padding: '10px 14px', color: '#94a3b8', fontSize: '0.85rem' }}>No courses found</div>
        )}
      </div>
      {value.length > 0 && (
        <div style={{ padding: '6px 14px', borderTop: '1px solid #e2e8f0', fontSize: '0.78rem', color: '#64748b', background: '#f0f4f8' }}>
          {value.length} course{value.length > 1 ? 's' : ''} selected
        </div>
      )}
    </div>
  );
}

export default function ClassCreate({ onClose, onSubmit, classItem = null }) {
  const [name, setName] = useState(classItem?.name || '');
  const [allCourses, setAllCourses] = useState([]);
  const [selectedCourseIds, setSelectedCourseIds] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    courseAPI.getAll().then(res => {
      const courses = Array.isArray(res.data) ? res.data : [];
      setAllCourses(courses);
      if (classItem) {
        const associated = classItem.Courses || classItem.courses || [];
        setSelectedCourseIds(associated.map(c => c.id));
      }
    }).catch(() => {});
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    if (!name.trim()) {
      Swal.fire({ icon: 'error', title: 'Validation', text: 'Class name is required' });
      return;
    }
    setLoading(true);
    try {
      const payload = { name, courses: selectedCourseIds.map(id => ({ id })) };
      if (classItem?.id) {
        await classAPI.update(classItem.id, payload);
      } else {
        await classAPI.create(payload);
      }
      onSubmit && onSubmit();
      Swal.fire({ icon: 'success', title: classItem?.id ? 'Class updated' : 'Class created', timer: 1800, showConfirmButton: false });
    } catch (err) {
      Swal.fire({ icon: 'error', title: 'Error', text: err.message });
    } finally {
      setLoading(false);
    }
  };

  const courseOptions = allCourses.map(c => ({ value: c.id, label: c.name }));

  return (
    <form onSubmit={submit}>
      <div className="eduss-global-modal-field-grid">
        <div className="eduss-global-modal-field" style={{ gridColumn: '1 / -1' }}>
          <label>Class Name *</label>
          <input value={name} onChange={e => setName(e.target.value)} placeholder="Enter class name" required />
        </div>
        <div className="eduss-global-modal-field" style={{ gridColumn: '1 / -1' }}>
          <label>Courses</label>
          <MultiSelect
            options={courseOptions}
            value={selectedCourseIds}
            onChange={setSelectedCourseIds}
            placeholder="courses"
          />
        </div>
      </div>

      <div className="eduss-global-modal-actions">
        <button type="button" className="eduss-global-modal-btn cancel" onClick={onClose}>
          <FaTimes /> Cancel
        </button>
        <button type="submit" className="eduss-global-modal-btn save" disabled={loading}>
          <FaSave /> {loading ? 'Saving…' : classItem?.id ? 'Update Class' : 'Create Class'}
        </button>
      </div>
    </form>
  );
}
